export function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
}

export function csvEscape(value, delim = ';') {
  if (value === null || value === undefined) return '';
  const s = String(value);
  const needsQuote = s.includes(delim) || s.includes('"') || /[\r\n]/.test(s);
  return needsQuote ? `"${s.replace(/"/g, '""')}"` : s;
}

export function downloadCsv({
  filename = 'export.csv',
  rows = [],
  columns = [],
  headers = null,
  delim = ';',
  withBom = true,
  formatValue = null,
}) {
  if (!Array.isArray(rows) || rows.length === 0) return;
  if (!Array.isArray(columns) || columns.length === 0) return;

  const BOM = '\uFEFF';
  const headerLine = (Array.isArray(headers) && headers.length === columns.length ? headers : columns).join(delim);

  const lines = rows.map((row) => {
    return columns
      .map((col) => {
        const raw = getByPath(row, col);
        const v = typeof formatValue === 'function' ? formatValue(row, col, raw) : raw;
        return csvEscape(v, delim);
      })
      .join(delim);
  });

  const csv = (withBom ? BOM : '') + [headerLine, ...lines].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadCsvBlob(blob, filename = 'export.csv') {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
